export default __webpack_public_path__ + "static/media/1484.de11cc0a.gif";